import { Tooltip, IconButton } from '@mui/material';
import React, { useContext } from 'react';

import AddEquipmentIcon from '@/assets/AddEquipmentIcon';
import RequestPermissionTooltip from '@/components/RequestPermissionTooltip';
import PermissionContext from '@/Contexts/Permissions';
import { PermissionActionEnum, PermissionEntityEnum } from '@/graphql/generated/graphql';

interface EquipmentRegisterToolbarType {
  onAddRecord: () => void;
}

const EquipmentRegisterToolbar: React.FC<EquipmentRegisterToolbarType> = ({ onAddRecord }) => {
  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const hasPermission = canPerformAction(PermissionActionEnum.Create, PermissionEntityEnum.Scheduling);

  return (
    <RequestPermissionTooltip
      hasPermission={hasPermission}
      requiredPermission={{
        action: PermissionActionEnum.Create,
        entity: PermissionEntityEnum.Scheduling,
      }}
      checkRequestExists={checkRequestExists}
      onRequest={requestPermission}
    >
      <Tooltip title={hasPermission ? 'Add Equipment' : ''}>
        <IconButton onClick={onAddRecord} size="small">
          <AddEquipmentIcon />
        </IconButton>
      </Tooltip>
    </RequestPermissionTooltip>
  );
};

export default EquipmentRegisterToolbar;
